<div class="flow-view">
  <header class="flow-view__header">
    <button type="button" class="flow-view__back-tab" (click)="backToFlows()">
      <i class="ms-Icon ms-Icon--Back" aria-hidden="true"></i>
      <span>Flows</span>
    </button>

    @if (flow) {
      <div class="flow-view__title">
        <h1>{{ flow.displayName || flow.flowName }}</h1>
        <p>{{ flow.environment }} / {{ flow.flowName }}</p>
      </div>
    }

    <nav class="flow-view__tabs" aria-label="Flow view tabs">
      <button type="button" [class.active]="activeTab === 'view'" (click)="selectTab('view')">
        <i class="ms-Icon ms-Icon--View" aria-hidden="true"></i>
        <span>View</span>
      </button>
      <button type="button" [class.active]="activeTab === 'runs'" (click)="selectTab('runs')">
        <i class="ms-Icon ms-Icon--History" aria-hidden="true"></i>
        <span>Runs</span>
      </button>
      <button type="button" [class.active]="activeTab === 'snapshots'" (click)="selectTab('snapshots')">
        <i class="ms-Icon ms-Icon--FullHistory" aria-hidden="true"></i>
        <span>Snapshots</span>
      </button>
      <button type="button" [class.active]="activeTab === 'json'" (click)="selectTab('json')">
        <i class="ms-Icon ms-Icon--CodeEdit" aria-hidden="true"></i>
        <span>JSON</span>
      </button>
      <button type="button" [class.active]="activeTab === 'diagram'" (click)="selectTab('diagram')">
        <i class="ms-Icon ms-Icon--VisioDiagram" aria-hidden="true"></i>
        <span>Diagram</span>
      </button>
    </nav>
  </header>

  @if (error) {
    <div class="flow-view__error">{{ error }}</div>
  }

  @if (flow) {
    <section class="flow-view__panel">
      @switch (activeTab) {
        @case ('view') {
          <div class="flow-view__tab-body flow-view__tab-body--view">
            <!-- Left column: Stats + Rules (66%) -->
            <div class="flow-view__column flow-view__column--main">
              <!-- Stats -->
              <div class="flow-view__section">
                <header class="flow-view__section-head">
                  <h2>Stats</h2>
                </header>
                <div class="flow-view__section-body">
                  <dl class="flow-view__stats">
                    <div>
                      <dt>State</dt>
                      <dd>{{ flow.flowState || '—' }}</dd>
                    </div>
                    <div>
                      <dt>Trigger</dt>
                      <dd>{{ flow.trigger || '—' }}@if (flow.triggerKind) {
                        <span> · {{ flow.triggerKind }}</span>
                      }</dd>
                    </div>
                    <div>
                      <dt>Actions</dt>
                      <dd>{{ flow.actionsCount || 0 }}</dd>
                    </div>
                    <div>
                      <dt>Runs loaded</dt>
                      <dd>{{ flow.runsCount || 0 }}</dd>
                    </div>
                    <div>
                      <dt>Failures</dt>
                      <dd>{{ flow.runsFailCount || 0 }}</dd>
                    </div>
                    <div>
                      <dt>Estimated rate</dt>
                      <dd>{{ flow.runsEstimateText || '—' }}</dd>
                    </div>
                    <div>
                      <dt>Last run</dt>
                      <dd>{{ flow.lastRun ? (flow.lastRun | date:'y-MM-dd HH:mm') : '—' }}</dd>
                    </div>
                    <div>
                      <dt>Last modified</dt>
                      <dd>{{ flow.modified ? (flow.modified | date:'y-MM-dd HH:mm') : '—' }}</dd>
                    </div>
                  </dl>
                </div>
              </div>
              <!-- Rules -->
              <div class="flow-view__section">
                <header class="flow-view__section-head">
                  <h2>Rules</h2>
                </header>
                <div class="flow-view__section-body">
                  <ng-container *ngTemplateOutlet="rulesFormTpl"></ng-container>
                </div>
              </div>
            </div>
            <!-- Right column: Owners + Connections (33%) -->
            <div class="flow-view__column flow-view__column--side">
              <!-- Owners -->
              <div class="flow-view__section">
                <header class="flow-view__section-head">
                  <h2>Owners</h2>
                </header>
                <div class="flow-view__section-body">
                  @if (flow.owners?.length) {
                    <ul class="flow-view__owners">
                      @for (owner of flow.owners; track owner) {
                        <li>
                          <span class="flow-view__owner-name">
                            {{ owner?.properties?.principal?.displayName || owner?.properties?.principal?.email || owner?.properties?.principal?.id || 'Unknown' }}
                          </span>
                          @if (owner?.properties?.principal?.email) {
                            <span class="flow-view__owner-email">
                              &lt;{{ owner.properties.principal.email }}&gt;
                            </span>
                          }
                          <span class="flow-view__owner-type">{{ owner?.properties?.principal?.type || '' }}</span>
                        </li>
                      }
                    </ul>
                  } @else {
                    <p class="flow-view__empty">No owner data loaded for this flow yet.</p>
                  }
                </div>
              </div>
              <!-- Connections -->
              <div class="flow-view__section">
                <header class="flow-view__section-head">
                  <h2>Connections</h2>
                </header>
                <div class="flow-view__section-body">
                  @if (hasConnections) {
                    <ul class="flow-view__connections">
                      @for (ref of connectionRefs; track ref) {
                        <li>
                          <span class="flow-view__conn-name">{{ ref.displayName }}</span>
                          @if (ref.api) {
                            <span class="flow-view__conn-api">{{ ref.api }}</span>
                          }
                          @if (ref.key) {
                            <span class="flow-view__conn-key">{{ ref.key }}</span>
                          }
                        </li>
                      }
                    </ul>
                  } @else {
                    <p class="flow-view__empty">No connection references on this flow.</p>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        @case ('runs') {
          <div class="flow-view__tab-body flow-view__tab-body--grid">
            <app-flow-runs [flow]="flow" [admin]="admin" [deep]="deep" [status]="status"></app-flow-runs>
          </div>
        }
        @case ('snapshots') {
          <div class="flow-view__tab-body">
            <app-flow-versions [flow]="flow"></app-flow-versions>
          </div>
        }
        @case ('json') {
          <div class="flow-view__tab-body">
            <app-flow-detail [flow]="flow" [editorType]="advanced ? 'FlowAdvanced' : 'Flow'"></app-flow-detail>
          </div>
        }
        @case ('diagram') {
          <div class="flow-view__tab-body">
            <app-flow-diagram [flowName]="flow.flowName"></app-flow-diagram>
          </div>
        }
      }
    </section>
  } @else {
    <div class="flow-view__loading">Loading flow...</div>
  }

  <!-- Shared Rules form — rendered in the View tab's Rules section and in the
  dedicated Rules tab. Single FormGroup binding so changes from either
  location stay in sync. -->
  <ng-template #rulesFormTpl>
    <div class="flow-view__rules" [formGroup]="rulesForm">
      <label class="flow-view__check">
        <input type="checkbox" formControlName="monitor" />
        <span>Monitor this flow</span>
      </label>

      <label class="flow-view__check">
        <input type="checkbox" formControlName="notifyOnFail" />
        <span>Email when a run fails</span>
      </label>

      <label class="flow-view__check">
        <input type="checkbox" formControlName="notifyOnMissed" />
        <span>Email when the flow does not run</span>
      </label>

      <label class="flow-view__field">
        <span>Missing days threshold</span>
        <input type="number" min="0" formControlName="missingDays" />
      </label>

      <label class="flow-view__field">
        <span>Notification email</span>
        <input type="email" formControlName="email" />
      </label>

      <button type="button" class="flow-view__save" [disabled]="savingRules || rulesForm.invalid" (click)="saveRules()">
        Save Rules
      </button>
    </div>
  </ng-template>

</div>
